import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { btnSecondary, easeOut } from "./primitives";

export default function FinalCta({ onOpenLead }) {
  return (
    <section className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: easeOut }}
          className="relative overflow-hidden rounded-[2rem] bg-[#0A1128] px-6 py-16 text-center sm:px-16 sm:py-24"
        >
          <div className="pointer-events-none absolute inset-0 grid-bg opacity-[0.15]" aria-hidden />
          <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[600px] -translate-x-1/2 rounded-full bg-[#0052FF]/40 blur-[120px]" aria-hidden />
          <div className="relative mx-auto max-w-2xl">
            <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">
              Source in bulk.
              <br />
              <span className="text-[#60A5FA]">Manage with confidence.</span>
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
              Purchase directly from verified Turkish manufacturers while managing production,
              inspection, freight and shipment visibility inside one connected Workspace.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <button
                data-testid="final-primary-cta"
                onClick={() => onOpenLead("create_bulkcontainer")}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#0A1128] transition-colors duration-200 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A1128]"
              >
                Create Your BulkContainer™ <ArrowRight className="h-4 w-4" />
              </button>
              <button
                data-testid="final-secondary-cta"
                onClick={() => onOpenLead("create_workspace")}
                className={btnSecondary + " !border-white/20 !bg-white/5 !text-white hover:!bg-white/10"}
              >
                Create Your Free Workspace
              </button>
            </div>
            <p className="mt-6 text-[13px] font-medium text-slate-400">
              Factory Direct Purchasing · No Product Markups · One Workspace
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
